import React from 'react';
import cn from 'classnames';

import styles from './Table.module.sass';
import { Loader } from '../../../../components/Loader';
import Row from './Row';

// data
import { IEventListItem, IPaginatedResponse } from '@types';
import { Paginate } from 'components/Paginate';

interface TableProps {
  className?: string;
  isRequestLoading: boolean;
  list: IPaginatedResponse<IEventListItem> | undefined;
  onDelete: (id: string) => void;
  pageCount: number;
  handlePageChange: (selectedItem: { selected: number }) => void;
}

const Table: React.FC<TableProps> = ({ className, list, isRequestLoading, pageCount, handlePageChange }) => {
  return (
    <>
      {isRequestLoading && <Loader />}
      <div className={cn(styles.wrapper, className)}>
        <div className={cn(styles.table)}>
          <div className={cn(styles.row)}>
            <div className={styles.col}></div>
            <div className={styles.col}>სახელი</div>
            <div className={styles.col}>თარიღი</div>
            <div className={styles.col}></div>
          </div>

          {!isRequestLoading && list?.data?.items.map(event => <Row item={event} key={event.id} />)}
        </div>
        <Paginate pageCount={pageCount} handlePageClick={handlePageChange} />
      </div>
    </>
  );
};

export default Table;
